export default __webpack_public_path__ + "static/media/home-track-mobile-red.a5553b0a.svg";